import { LodashExtractor } from '@ddt-web/data-service';

import { FactMappingInterface } from '../../../../models/fact-mapping.interface';
import { FactExtractor } from '../../fact-extractor';

export const BELOW_AVERAGE_ETFS_FACTS: { [factName: string]: FactMappingInterface } = {
	etfPercentage: {
		extractor: new FactExtractor([new LodashExtractor('positionDetails.children')], children => {
			return children.filter(child => child.legalType === 'ASSET_LEGAL_TYPE_ETF').map(child => child.weight).reduce((a, b) => a + b, 0);
		})
	}
};
